<template>
  <div class="ticket-romancecar">
    <MFITTIndexThumbnailDisp />

    <div class="form top-ticket">
      <MFITTOperationInformation />

      <div class="actions">
        <ItemButton
          label="特急ロマンスカー予約・購入"
          action-type="btn-primary"
          @clicked="goToNextPage"
        />
      </div>

      <MFITTExternalLinkButton
        title="特急券の詳しい説明はこちら"
        url="https://www.emot.jp/service/detail/romancecar.html"
      />

      <hr />

      <div
        v-for="(limitedExpressTicket, index) in myLimitedExpressTickets"
        :key="index"
      >
        <MFITTResevationCard :limited-express-ticket="limitedExpressTicket" />
      </div>
    </div>

    <!--Click the Receive button and the confirmation dialog if Purchase Ticket is an old version.-->
    <DialogPurchaseVersionWarning ref="DialogPurchaseVersionWarning" />
  </div>
</template>

<script>
import DialogPurchaseVersionWarning from "@/views/Components/Organisms/TicketStore/Dialog/DialogPurchaseVersionWarning";
import { watchEffect, computed, ref } from "vue";
import { useStore } from "vuex";
import mfittService from "@/services/MFITT";
import nativeHandlerService from "@/services/nativeHandler";
import { isAppVersionGreater } from "@/lib/compareVersion";

export default {
  name: "TemplateMfittIndex",
  components: {
    DialogPurchaseVersionWarning: DialogPurchaseVersionWarning,
  },
  setup() {
    const store = useStore();

    // ログインしているかどうか
    const isLogin = store.getters["common/isLogin"];

    //default order
    const defaultMyLimitedExpressTickets = computed(
      () => store.getters["MFITT/myLimitedExpressTickets"]
    );

    //will be re-order
    const myLimitedExpressTickets = ref(defaultMyLimitedExpressTickets.value);

    const myCoupons = computed(() => store.getters["MFITT/myCoupons"]);
    const appVersion = computed(() => store.getters["common/appVersion"]);
    const isNotTargetVersion = ref(false);
    const DialogPurchaseVersionWarning = ref(null);
    const device = computed(() => store.getters["common/device"]);

    //ticket have departure_at after 90m will be reorder
    myLimitedExpressTickets.value = mfittService.reorderMyLimitedExpressTickets(
      myLimitedExpressTickets
    );

    // 対象のバージョンかどうか確認
    const checkVersion = () => {
      let isLessThanTargetVersion = false;
      switch (device.value) {
        case "IOS":
          isLessThanTargetVersion = !isAppVersionGreater(
            appVersion.value,
            "2.8.3"
          );
          break;
        case "ANDROID":
          isLessThanTargetVersion = !isAppVersionGreater(
            appVersion.value,
            "2.8.4"
          );
          break;
        default:
          isLessThanTargetVersion = false;
          break;
      }
      isNotTargetVersion.value = isLessThanTargetVersion;
    };

    const goToNextPage = async () => {
      if (isNotTargetVersion.value) {
        openPurchaseVersionWarning();
      } else if (!isLogin) {
        // 未ログインの場合はダイアログ表示して予約画面に遷移させない
        nativeHandlerService.returnNativeAppToAccountPage();
      } else {
        if (myCoupons.value && myCoupons.value.length > 0) {
          // クーポンがあればクーポン選択画面へ
          mfittService.goToSelectCoupon();
        } else {
          // クーポンがない場合は特急ロマンスカー予約・購入画面へ
          mfittService.goToBooking1();
        }
      }
    };

    const openPurchaseVersionWarning = () => {
      DialogPurchaseVersionWarning.value.openDialog();
    };

    watchEffect(() => {
      if (appVersion.value != null && appVersion.value != undefined) {
        checkVersion();
      }
    });

    return {
      myLimitedExpressTickets,
      goToNextPage,
      openPurchaseVersionWarning,
      DialogPurchaseVersionWarning,
    };
  },
};
</script>
<style scoped lang="scss">
.ticket-romancecar .form {
  margin: 20px 15px;
}

.ticket-romancecar .form .column {
  margin-bottom: 16px;
}

/*時間のレイアウト*/
.ticket-romancecar .form .time {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

.ticket-romancecar .form .time .row:first-child {
  width: 40%;
  margin-right: 10px;
}

.ticket-romancecar .form .time .row:last-of-type {
  width: 60%;
  margin-top: 4px;
}

.ticket-romancecar hr {
  margin: 25px -15px 15px -15px;
  border: none;
  border-top: 1px solid #e0e0e0;
}
</style>
